var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 16.4688H1.0625C0.779167 16.4688 0.53125 16.2208 0.53125 15.9375V12.2188C0.53125 11.9354 0.779167 11.6875 1.0625 11.6875H4.25V8.5C4.25 8.21667 4.49792 7.96875 4.78125 7.96875H7.96875V4.78125C7.96875 4.49792 8.21667 4.25 8.5 4.25H11.6875V1.0625C11.6875 0.779167 11.9354 0.53125 12.2188 0.53125H15.9375C16.2208 0.53125 16.4688 0.779167 16.4688 1.0625V15.9375C16.4688 16.2208 16.2208 16.4688 15.9375 16.4688ZM1.59375 15.4062H15.4062V1.59375H12.75V4.78125C12.75 5.06458 12.5021 5.3125 12.2188 5.3125H9.03125V8.5C9.03125 8.78333 8.78333 9.03125 8.5 9.03125H5.3125V12.2188C5.3125 12.5021 5.06458 12.75 4.78125 12.75H1.59375V15.4062Z",
    fill: "#1C452B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairs);
export default __webpack_public_path__ + "static/media/stairs.c56d97b89f925d8ce23a11eb695a3f46.svg";
export { ForwardRef as ReactComponent };